module.exports = __webpack_public_path__ + "static/img/training.a4a843d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/products/screenshots/training.png
// module id = Y0pS
// module chunks = 0